"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BreadcrumbLink = void 0;
var React = _interopRequireWildcard(require("react"));
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _qa = require("../../../utils/qa");
var _Link = require("../../Link");
var _BreadcrumbLinkModule = _interopRequireDefault(require("./BreadcrumbLink.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const BreadcrumbLink = exports.BreadcrumbLink = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    id,
    className,
    as,
    underline = false,
    isActive,
    onClick,
    href,
    to,
    testId,
    ...props
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Link.Link, {
    ...props,
    to: to ?? href,
    testId: (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    ref: ref,
    as: as || 'subTitleExtraSmall',
    underline: underline,
    disabled: isActive,
    className: (0, _classify.default)(_BreadcrumbLinkModule.default.breadcrumbLink, {
      [_BreadcrumbLinkModule.default.active]: isActive ?? window.location.href.includes(to ?? href ?? '')
    }, className),
    onClick: e => {
      onClick?.(e, id);
    }
  });
});
BreadcrumbLink.displayName = 'BreadcrumbLink';